import React, {useRef} from "react";
import {Box} from "@mui/material";
import {QRCodeSVG} from "qrcode.react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import PrintIcon from "@mui/icons-material/Print";
import CustomTypography from "../../../core/components/ui/CustomTypography";

const PrintQRCodeDialog = (props) => {
  const {open, setOpen, data} = props;

  const printRef = useRef();

  const handlePrint = () => {
  const printContents = printRef.current.innerHTML;
  const newWindow = window.open("", "_blank", "width=1000,height=600");

    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                text-align: center;
                padding: 20px;
              }
              .qr-container {
                margin: 0 auto;
                border: 1px dashed #ccc;
              }
            </style>
          </head>
          <body>
            <div class="qr-container">
              ${printContents}
            </div>
            <script>
              window.onload = function() {
                window.print();
              };
            </script>
          </body>
        </html>
      `);
      newWindow.document.close();
    }
  } 

  const handleClose = () => {
    setOpen(false);
  }

  const actions = [
    {
      label: "Print QR Code",
      startIcon: <PrintIcon />,
      onClick: (e) => handlePrint()    
    }
  ]

  const globalSx = {
    //
  }


  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      subtitle={""}
      hasDividers={false}
      hasCloseIcon={false}
      content={
        <Box ref={printRef}>
          <Box sx={{ 
            p: 4,                              
            border: "1px dashed #ccc", }}>
<CustomTypography 
                                variant="h2"
                                text={"Vehicle Gate Pass"}
                                customStyles={{
                                    marginBottom: "32px", 
                                    fontSize: 35,
                                    fontWeight: 700, 
                                    textAlign: "center"
                                }}
                            />
                        <QRCodeSVG
                            value={data?.gatePassEntity?.online_qr}
                            size={400}
                           
                            style={{ display: "block", 
                                margin: "0 auto" 
                            }}
                        />
                         <CustomTypography 
                                variant="h3"
                                text={data?.vehicleEntity.plate_number}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 20,
                                    fontWeight: 500, 
                                    textAlign: "center",
                                    marginTop: "24px"
                                }}
                            />
                    </Box>
                </Box>
                }
                actions={actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
  )
}

export default PrintQRCodeDialog
